export const WEEK_IS_SECONDS = 604_800_000;

export const MAX_TIMER_DURATION = 0x7fffffff; // ~24.8 days

export type DayOfWeek = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export type TimeString = `${ number }:${ number }:${ number }`;

export interface TimeObject {
  hour: number;
  minute: number;
  second: number;
}

export const parseTimeObjectFromString = (time: string): TimeObject => {
  const [hour, minute, second] = time.split(':').map(Number);

  if (hour < 0 || hour > 23 || minute < 0 || minute > 59 || (
    second !== undefined && (
      second < 0 || second > 59
    )
  )) {
    throw new Error(`Invalid time format: ${ time }`);
  }

  return {
    hour: hour,
    minute: minute,
    second: second ?? 0,
  };
};
